import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as fusionActions } from '../reducers/fusion';

const useChannels = (selectedProduct) => {
  const { currentSubproducts } = useSelector(state => state.fusion);
  const dispatch = useDispatch();

  useEffect(() => {
    const { product, recom } = selectedProduct;
    const { taxonomy } = product;
    const { promoCode, prodCode } = recom;
    dispatch(
      fusionActions.getSubproductsFromProductsBegins({
        recomCode: taxonomy || prodCode,
        promoCode,
      })
    );
  }, [dispatch, selectedProduct]);

  return currentSubproducts;
};

export default useChannels;
